export default ({ style }) => (
	<svg
		id="Layer_3"
		data-name="Layer 3"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 27 27"
	>
		<path
			style={style}
			className="cls-1"
			d="M17.1,9.617a3.6,3.6,0,1,0-3.6,3.6A3.6,3.6,0,0,0,17.1,9.617Zm-6.7,0a3.1,3.1,0,1,1,3.1,3.1A3.1,3.1,0,0,1,10.4,9.617Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M13.5,14.04a6.7,6.7,0,0,0-6.691,6.691.25.25,0,0,0,.25.25H19.941a.25.25,0,0,0,.25-.25A6.7,6.7,0,0,0,13.5,14.04ZM7.314,20.481a6.191,6.191,0,0,1,12.372,0Z"
		/>
	</svg>
)
